module.exports = __webpack_public_path__ + "static/round-lake-2abf48c78dc4ad5b44eafb4e2ee59ec7.jpg";